import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";
import {DungeonQuestGameConfig} from "../../DungeonQuestGameConfig";
import {TimelineLite, TweenLite} from "gsap";

/**
 * Created by Jonas Wålekvist on 2018-06-28.
 */

export class BackgroundDividers extends PIXI.Container {
    private readonly _dividerGlowRight:PIXI.Sprite;
    private readonly _dividerGlowLeft:PIXI.Sprite;
    private readonly _attentionDividerRight:PIXI.Sprite;
    private readonly _attentionDividerLeft:PIXI.Sprite;

    constructor(width:number, height:number) {
        super();

        this._dividerGlowRight = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BG_DIVIDER_GLOW)[0]);
        this._dividerGlowRight.anchor.set(0.5, 0.5);
        this._dividerGlowRight.position.set(Math.floor(width), 250);


        this._dividerGlowLeft = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BG_DIVIDER_GLOW)[0]);
        this._dividerGlowLeft.anchor.set(0.5, 0.5);
        this._dividerGlowLeft.position.set(-2, 100);


        this.addChild(this._dividerGlowLeft);
        this.addChild(this._dividerGlowRight);


        this._attentionDividerRight = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.FS_DIVIDER)[0]);
        this._attentionDividerRight.blendMode = PIXI.BLEND_MODES.ADD;
        this._attentionDividerRight.height = height;
        this._attentionDividerRight.anchor.set(0.5, 1);
        this._attentionDividerRight.position.set(Math.floor(width), DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT);


        this._attentionDividerLeft = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.FS_DIVIDER)[0]);
        this._attentionDividerLeft.blendMode = PIXI.BLEND_MODES.ADD;
        this._attentionDividerLeft.height = height;
        this._attentionDividerLeft.anchor.set(0.5, 1);
        this._attentionDividerLeft.position.set(-2, DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT);

        this.addChild(this._attentionDividerRight);
        this.addChild(this._attentionDividerLeft);

        this._attentionDividerRight.alpha = 0;
        this._attentionDividerLeft.alpha = 0;
    }


    public showAttention(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._attentionDividerRight, duration, {alpha : 1}),
            new TweenLite(this._attentionDividerLeft, duration, {alpha : 1})
        ]);
        return tl;
    }

    public hideAttention(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._attentionDividerRight, duration, {alpha : 0}),
            new TweenLite(this._attentionDividerLeft, duration, {alpha : 0})
        ]);
        return tl;
    }

    public tint(color:number) {
        this._attentionDividerRight.tint = color;
        this._attentionDividerLeft.tint = color;
    }
}